<template>
  <div>
    <ul>
      <li v-for="menu in menus" :key="menu.menuid" :class="[menu.menuid===menuid?'is-active':'']" @click="menuid=menu.menuid;">{{menu.menuname}}</li>
      <li @click="showClick">
        {{btn}}
      </li>
    </ul>
    <div style="clear:left;"></div>
    <div :class="[isShow?'hidediv':'showdiv']">

      <el-menu class="el-menu-vertical-demo" :collapse="isShow" @open="handleOpen" @close="handleClose" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
        <el-submenu v-for="(menu) in menus.filter(item => item.menuid === menuid)[0].children" :key="menu.menuid" :index="menu.menuid">
          <template slot="title">
            <i :class="['iconfont',menu.icon]"></i>
            <span>{{menu.menuname}}</span>
          </template>
          <el-menu-item v-if="menu.children!==undefined" v-for="(c) in menu.children" :key="c.menuid" :index="c.menuid">
            <template slot="title">
              <i :class="['iconfont',menu.icon]"></i>
              <span>{{c.menuname}}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import menus from '@/common/menu'

export default {
  data () {
    return {
      btn: '显示',
      isShow: true,
      menus: menus.menus,
      menuid: '1'
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    showClick () {
      this.isShow = !this.isShow
      this.btn = this.isShow ? '显示' : '隐藏'
    }
  }
}
</script>

<style scoped>
@import '../../css/iconfont.css';
ul {
  list-style: none;
}

li {
  float: left;
  padding: 0 10px;
}

.showdiv {
  width: 200px;
}
.hidediv {
  width: 64px;
}

.is-active {
  background-color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/test.vue